// extracted by mini-css-extract-plugin
export var avatarContainer = "_5v-0";
export var avatarTypingWave = "_5v-i";
export var gray = "_5v-f";
export var green = "_5v-c";
export var icon = "_5v-9";
export var image = "_5v-1";
export var lg = "_5v-6";
export var md = "_5v-5";
export var presenceDot = "_5v-b";
export var red = "_5v-d";
export var sm = "_5v-4";
export var status = "_5v-a";
export var typingDot = "_5v-h";
export var typingPill = "_5v-g";
export var xl = "_5v-7";
export var xs = "_5v-3";
export var xxl = "_5v-8";
export var xxs = "_5v-2";
export var yellow = "_5v-e";